import React from 'react'

class EditableItemName extends React.Component {

  static defaultProps = {
    value: '',
    editMode: false
  }

  constructor (props) {
    super(props)
    this.state = { value: this.props.value, editMode: this.props.editMode }
  }

  onChange = (e) => {
    this.setState(Object.assign(this.state, { value: e.target.value }))
  }

  onCancel = (e) => {
    this.setState(Object.assign(this.state, { value: this.props.value }))
    this.toggleMode(e)
  }

  onSave = (e) => {
    this.props.onChange({ target: { value: this.state.value, name: 'name' }})
    this.toggleMode(e)
  }

  toggleMode = (e) => {
    const action = e.target.getAttribute('data-action')
    if (action == 'edit') { this.setState(Object.assign(this.state, { editMode: true })) }
    else this.setState(Object.assign(this.state, { editMode: false }))
  }

  render () {
    const { value, editMode } = this.state

    if (editMode) {
      return (
        <div>
          <input type="text" name="name" value={value} onBlur={this.onChange} onChange={this.onChange} className="form-control" />
          <i className="fa fa-check" title="Save" aria-hidden="true" data-action="save" onClick={this.onSave}></i>
          <i className="fa fa-window-close" title="Cancel" aria-hidden="true" data-action="cancel" onClick={this.onCancel}></i>
        </div>
      )
    }

    return (
      <div>
        {value}
        <i className="fa fa-edit" title="Edit" aria-hidden="true" data-action="edit" onClick={this.toggleMode}></i>
      </div>
    )
  }

}

export default EditableItemName
